<template>
  <div
    :class="[$style.container, computedClasses]"
    @click="$e => $emit('click', $e)"
  >

    <div :class="$style.main">
      <div
        v-if="$slots.label"
        :class="[$style.label, computedClasses]"
      >
        <slot name="label" />
      </div>

      <div :class="$style.input">
        <slot name="default" />
      </div>
    </div>

    <div v-if="isShownAdditional" :class="$style.additional" @click.stop>
      <div :class="$style.additionalIcon">
        <div v-if="disabled" :class="[$style.icon, computedClasses]">
          <!-- <lock-circle-icon /> -->
        </div>
        <div v-else-if="error" :class="[$style.icon, computedClasses]">
          <!-- <alert-circle-icon /> -->
        </div>
      </div>
    </div>

  </div>
</template>

<script>
// import LockCircleIcon from 'atoms/icons/security/LockCircle';
// import AlertCircleIcon from 'atoms/icons/notifications/AlertCircle';

export default {
  name: 'InputTemplate',
  components: {
    // LockCircleIcon,
    // AlertCircleIcon,
  },
  props: {
    disabled: {
      type: Boolean,
      default: () => false,
    },
    filled: {
      type: Boolean,
      default: () => false,
    },
    focused: {
      type: Boolean,
      default: () => false,
    },
    error: {
      type: Boolean,
      default: () => false,
    },
  },
  computed: {
    computedClasses() {
      return {
        [this.$style.invalid]: this.error,
        [this.$style.disabled]: this.disabled,
        [this.$style.filled]: this.filled,
        [this.$style.focused]: this.focused,
      };
    },
    isShownAdditional() {
      if (this.$slots.icon || this.$slots.link) {
        return true;
      }

      return this.disabled || this.error;
    },
  },
};
</script>

<style lang="sass" module>
  .container
    display: flex
    padding: 16px 20px
    border-radius: 5px //
    overflow: hidden //
    outline: 1px solid transparent
    background-color: var(--color-white)
    box-shadow: 0px 1px 2px rgba(189, 189, 189, 0.5) //
    transition: all 0.1s linear
    cursor: text

    &.focused
      // outline: 1px solid rgba(0, 0, 0, 0.25)

    &.disabled
      // background-color: var(--color-dark-blue2)
      // outline: 1px solid rgba(255, 255, 255, 0.1)
      cursor: not-allowed

    &.invalid
      outline: 1px solid var(--color-red)

  .main
    width: 100%

  .label
    margin-bottom: 6px
    font-weight: 500
    font-size: 14px
    line-height: 18px
    color: var(--color-grey-2)

    label
      display: flex
      cursor: text

    &.filled
      color: var(--color-grey-2)

    &.focused
      color: var(--color-green)

    &.disabled
      // color: rgba(255, 255, 255, 0.5)

      label
        cursor: not-allowed

    &.invalid
      color: var(--color-red)

  .input
    display: flex

  .additional
    display: flex
    flex-direction: column
    margin-left: 10px
    z-index: 10

  .additionalIcon
    display: flex
    justify-content: flex-end

  // @TODO: все это выглядит лишним, переработать
  .icon
    width: 24px
    height: 24px

    svg
      path
        fill: var(--color-white)

    &.focused
      svg
        path
          fill: var(--color-black-1)

    &.disabled
      svg
        path
          fill: rgba(86, 86, 99, 1)

    &.invalid
      width: 18px
      height: 18px

      svg
        path
          fill: #FF5172
</style>
